module.exports = __webpack_public_path__ + "static/media/logo-default.50e42eb9.svg";